import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'
import $api from '@/plugins/axiosInstance.js'
import $api2 from '@/plugins/axiosInstance2.js'
import CONST from '@/const'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  GETWITHDRAWAL: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/withdrawal', params: payload})
        .then(result =>{return result.data})
    }
  },
  GET_USER_WITHDRAWAL: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: `/admin/user/${payload.id}/withdrawal`, params: payload.params})
        .then(result =>{return result})
    }
  },
  POST_USER_WITHDRAWAL: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'post', url: `/admin/user/${payload.id}/withdrawal`,})
        .then(result =>{return result})
    }
  },
  FULFILL_WITHDRAWAL_REQUEST: {
    root: true,
    handler(namespacedContext, payload){
      return $api2({method: 'put', url: '/admin/user/'+ payload.id + '/withdrawal/' + payload.withdrawal_id + '/fulfill', data: payload.params})
      .then(result =>{
        return result
      })
    }
  },
  REJECT_WITHDRAWAL: {
    root: true,
    handler(namespacedContext, payload){
      return $api2({method: "put", url: `/admin/user/${payload.id}/withdrawal/${payload.withdrawal_id}/reject`, data: payload.params})
      .then(result =>{
        return result
      })
    }
  },
  PUT_TAX_INVOICE_DATE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({method: "put", url: `/admin/user/${payload.id}/withdrawal/${payload.withdrawal_id}/tax_invoice_read`, data: payload.params})
      .then(result =>{
        return result
      })
    }
  },
  GET_WITHDRAWAL_EXCEL: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: '/withdrawal/export',data :  payload, responseType: 'blob' })
        .then(result =>{return result})
    }
  },
  GET_SETTLEMENT_EXCEL : {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: '/withdrawal/export-settlement',data :  payload, responseType: 'blob' })
        .then(result =>{return result})
    }
  },
  GET_WITHDRAWAL_SUMMARY: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/withdrawal/summary', params: payload })
        .then(result => { return result.data })
    }
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
